export const setUppercase = (data) => {
  const processItem = (item) => {
    // If it's just a string value
    if (typeof item === "string") {
      return item.toUpperCase();
    }

    // If it's an object
    if (item && typeof item === "object") {
      return Object.fromEntries(
        Object.entries(item).map(([key, value]) => [
          key,
          key === "email" ||
          key === "status" ||
          key === "order_status" ||
          key === "payment_status" ||
          key === "url" ||
          key === "file_url" ||
          key === "image" ||
          key === "description" ||
          typeof value !== "string"
            ? value
            : value.toUpperCase(),
        ])
      );
    }

    return item;
  };

  // If array → map
  if (Array.isArray(data)) {
    return data.map(processItem);
  }

  // Single object or single string
  return processItem(data);
};
